// extracted by mini-css-extract-plugin
export default {"welcome":"Welcome-module__welcome__3fNmp","title":"Welcome-module__title__cy7rr","stats":"Welcome-module__stats__eAsxA","stat":"Welcome-module__stat__H0vqH"};